module.exports = __webpack_public_path__ + "img/pt-35.485fdf46.jpg";